import DiscoverBtn from "./search-popup-mobile/discoverBtn";

export default function EmtyWishList() {
  return (
    <div className="text-left w-full mb-10">
      <p className="text-c22 text-black22 font-semibold mb-2">Create your first wishlist</p>
      <p className="text-sm text-gray-400 mb-c20 ">
        As you search, click the heart icon to save your favorite places and
        Experiences to a wishlist.
      </p>
      <DiscoverBtn/>
    </div>
  );
}
